import template from './time_approve.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';
import * as Navbar from '../../lib/update_navbar_notifications.js';

class TimeApproveViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);
		this.table_report = ko.observableArray();
		this.download_data = ko.observableArray();
		this.manager = ko.observableArray([]);
		this.employee_id = ko.observable();

		//options
		this.table_visible = ko.observable(false);
		this.current_page_number = ko.observable(1);
		this.current_page_size = ko.observable(10);
		this.page_count = ko.observable(1);
		this.pagination_summary = ko.observable('');
		this.number_of_records = ko.observableArray([10, 20, 50, 100]);
		this.selected_number_of_records = ko.observable(10);
		this.has_entries = ko.computed(() => this.table_report().length > 0);
	};

	async reject_entry(row)
	{ 
		row.view_only = true;
		await Grape.dialog.open('TimeLoggedReject',{ row: row, task_time_id: row.task_time_id });
		this.page.updateData();
	}

	async view_entry(row)
	{
		row.view_only = true; 
		await Grape.dialog.open('LogTime', { row: row });
		this.page.updateData();
	};

	async approve_entry(row)
	{
		let respsonse = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr("Are you sure you want to approve the entry?")});
		if (respsonse)
		{
			let res = await Grape.fetches.postJSON('/time_management/approve_time_logged_entry',
			{
				employee_id: this.employee_id(),
				task_time_id: row.task_time_id
			});
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully approved time logged entry.'), title: tr('Success') });
				this.page.updateData();
			}
			else if (res.status == 'ERROR')
			{
				Grape.alerts.apiError(res);
				this.page.updateData();
			}
			else if (res.error)
			{
				Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error') });
				this.page.updateData();
			}
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		};
	}

	async approve_all_entries() {
		let response = await Grape.alerts.confirm({
			type: 'warning',
			title: tr('Warning'),
			message: tr("Are you sure you want to approve all time logged entries?")
		});

		if (response) {
			this.loader(true);
			try {
				// Get all task_time_ids from the current table
				const task_time_ids = this.table_report().map(row => row.task_time_id);
				let res = await Grape.fetches.postJSON('/time_management/approve_all_time_logged_entries', {
					employee_id: this.employee_id(),
					task_time_ids: task_time_ids
				});

				if (res.status == 'OK') {
					Grape.alerts.alert({
						type: 'success',
						message: tr('Successfully approved all time logged entries.'),
						title: tr('Success')
					});
					this.page.updateData();
				} else if (res.status == 'ERROR') {
					Grape.alerts.apiError(res);
				} else if (res.error) {
					Grape.alerts.alert({
						type: 'error',
						message: res.error,
						title: tr('Error')
					});
				} else {
					Grape.alerts.alert({
						type: 'error',
						message: tr('Something went wrong...'),
						title: tr('Error')
					});
				}
			} finally {
				this.loader(false);
			}
		}
	}

	show_report_help()
	{
		Grape.dialog.open('ApproveTimeHelp', { employee_id: this.page.bindings.id });
	}
};

class TimeApprovePage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new TimeApproveViewModel(this);
	}

	init()
	{
		document.title = tr('Approve Time Logged');
		window.current_page_title(tr('Approve Time Logged'));
		this.viewModel.employee_id(Utils.current_employee_id());
		this.load_entries();
	}

	updateData()
	{
		this.loadTimeTable();
		Navbar.updateTimeToApproveCount();
	}

	async load_entries()
	{
		this.viewModel.loader(true);

		await this.loadTimeTable();

		this.viewModel.loader(false);
	}

	async loadTimeTable()
	{
		let table_query_options = this.set_table_query_options()
		if (!table_query_options)
			return; 

		table_query_options.employee_id = this.viewModel.employee_id(); 
		table_query_options.sortorder = 'ASC';
		table_query_options.offset = (this.viewModel.current_page_number() - 1) * this.viewModel.current_page_size();
		table_query_options.limit = this.viewModel.current_page_size();


		this.viewModel.table_visible(true); 
		let res = await Grape.fetches.postJSON('/time_management/get_time_to_approve', table_query_options);
		if (res.status !== 'ERROR')
		{
			if (res.report.approve != null) {
				const processed_data = res.report.approve.map(entry => ({
					...entry,
					start_time: Utils.get_timestamp(new Date(entry.start_time)),
					end_time: Utils.get_timestamp(new Date(entry.end_time))
				}));

				this.viewModel.table_report(processed_data);
				this.viewModel.page_count(Math.ceil(res.report.count / this.viewModel.current_page_size()));
				this.viewModel.pagination_summary(`Showing page ${this.viewModel.current_page_number()} of ${this.viewModel.page_count()} (${res.report.count} rows)`);
				this.viewModel.table_visible(true);
			} else {
				this.viewModel.table_report([]);
				this.viewModel.table_visible(false);
			}
		}
	};

	set_table_query_options()
	{
		let table_query_options = {
			offset: 0,
			limit: 1000000000,
		};

		table_query_options.employee_id =  this.viewModel.employee_id();
		return table_query_options;
	}
};

export default {
	route: '[/]time_management/time_approve',
	page_class: TimeApprovePage,
	template: template,
	template_filename: 'translation/time_approve'
};
